function uniqueByKey<T>(inn: T[], key: keyof T): T[] {
    let seen = new Set<unknown>();

    return inn.filter((it) => {
        if (seen.has(it[key])) return false;

        seen.add(it[key]);

        return true;
    })
}

export { uniqueByKey }
